import http from "@/tools/http";

export default {
  create(organizationUUID, data) {
    return http.post(`/organizations/${organizationUUID}/blockrules`, data);
  },
  getAll(organizationUUID, pagination) {
    return http.get(`/organizations/${organizationUUID}/blockrules`, { params: pagination });
  },
  update(organizationUUID, data) {
    return http.patch(`/organizations/${organizationUUID}/blockrules/${data.uuid}`, data);
  },
  delete(organizationUUID, blockruleUUID) {
    return http.delete(`/organizations/${organizationUUID}/blockrules/${blockruleUUID}`);
  },
  getCustomersBloked(organizationUUID, blockruleUUID, pagination) {
    return http.get(`/organizations/${organizationUUID}/blockrules/${blockruleUUID}/customers`, { params: pagination });
  }
};
